import React from 'react';
import { Box, Skeleton, useTheme } from '@mui/material';
import { RADIUS } from '../../theme/tokens';

/**
 * LoadingSkeleton
 * Shape-matched skeleton placeholders for common component types.
 *
 * @param {'card'|'list'|'stat'|'hero'|'listItem'} variant
 * @param {number} [count=1]
 */
function LoadingSkeleton({ variant = 'card', count = 1, sx = {} }) {
  const theme = useTheme();
  const items = Array.from({ length: count });

  if (variant === 'stat') {
    return (
      <Box sx={{ p: 2.5, ...sx }}>
        <Skeleton variant="rounded" width={44} height={44} sx={{ borderRadius: RADIUS.md, mb: 1.5 }} />
        <Skeleton variant="text" width="60%" height={32} />
        <Skeleton variant="text" width="80%" height={18} />
      </Box>
    );
  }

  if (variant === 'hero') {
    return (
      <Skeleton
        variant="rounded"
        width="100%"
        height={180}
        sx={{ borderRadius: RADIUS.lg, mb: 2, ...sx }}
      />
    );
  }

  if (variant === 'listItem') {
    return items.map((_, i) => (
      <Box key={i} sx={{ display: 'flex', gap: 2, alignItems: 'center', py: 1.5, ...sx }}>
        <Skeleton variant="circular" width={44} height={44} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="70%" />
          <Skeleton variant="text" width="50%" />
        </Box>
      </Box>
    ));
  }

  if (variant === 'list') {
    return items.map((_, i) => (
      <Box key={i} sx={{ mb: 1.5, ...sx }}>
        <Skeleton variant="rounded" width="100%" height={72} sx={{ borderRadius: RADIUS.lg }} />
      </Box>
    ));
  }

  // default: card
  return items.map((_, i) => (
    <Skeleton
      key={i}
      variant="rounded"
      width="100%"
      height={160}
      sx={{ borderRadius: RADIUS.lg, mb: 2, ...sx }}
    />
  ));
}

export default LoadingSkeleton;
